/**
 * Converts regular string to the kebab-case handle

 Example:
 radius changed -> radius-changed
 radiusChanged -> radius-changed
 radius_changed -> radius-changed
 raDiuScHan_ge d -> ra-diu-sc-han-ge-d

 * @param str
 */
export const convertToKebabCase = (str: string) => {
  return (str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g) || [])
    .map((x) => x.toLowerCase())
    .join('-');
};

/**
 * Simple hash function
 * @param source
 */
export const checksum = (source: string) => {
  const stringLen = source.length;
  let i;
  let char;
  let hash = 0;

  if (stringLen === 0) {
    return hash;
  }

  for (i = 0; i < stringLen; i++) {
    char = source.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash &= hash; // Convert to 32bit integer
  }

  return hash % 256;
};

/**
 * Used for "kebab-case" strings to have short handle with
 * checksum at the end to prevent duplicated ids in URL
 * @param handle
 */
export const getShortHandle = (handle: string) => {
  const splitted = handle.split('-');
  const unPostfixed = splitted.length > 2 ? `${splitted[0]}-${splitted[1]}` : handle;

  return unPostfixed + checksum(handle);
};
